import { Component, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageChannelService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnLoginStorageService } from "@bndes/bndes-ux4/bn-login";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import { LoginService } from './login.service';
import { TelaLoginBaseComponent } from './tela-login-base.component';

@Component({
    selector: 'login-novo',
    templateUrl: './login-novo.component.html',
    styleUrls: ['./login-novo.component.scss'],
    standalone: false
})
export class LoginNovoComponent extends TelaLoginBaseComponent {

  public classeImagemFundo = "bg bg";

  constructor(route: ActivatedRoute, 
    router: Router,
    usuarioService: BnUsuarioService,
    @Inject('bndesUxConfig') bndesUxConfig: any,
    loginStorageService: BnLoginStorageService,
    loginService: LoginService,
    messageService: MessageChannelService) {
      super(route, 
            router, 
            usuarioService, 
            bndesUxConfig,              
            loginStorageService, 
            loginService,
            messageService);
      this.trataImagemFundo();
  }

  trataImagemFundo() {
    this.classeImagemFundo += Math.floor(Math.random() * 4) + 1;
  }
}
